var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"custom-form-app"}},[_c('notifications',{attrs:{"classes":"notification-card"}}),_c('custom-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }